import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { throttleWrapper } from '../utils/lazyload';
var iframeStyle = {
  position: 'absolute',
  left: 0,
  width: 0,
  height: '100%',
  border: 0
};

var Expand =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Expand, _PureComponent);

  var _super = _createSuper2(Expand);

  function Expand(props) {
    var _this;

    _classCallCheck(this, Expand);

    _this = _super.call(this, props);
    _this.element = void 0;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    _this.bindIframe = _this.bindIframe.bind(_assertThisInitialized(_this));
    _this.setHeight = _this.setHeight.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Expand, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setHeight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setExpandHeight(0);
    }
  }, {
    key: "setHeight",
    value: function setHeight() {
      if (this.element) {
        this.props.setExpandHeight(this.element.clientHeight);
      }
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      this.element = el;
    }
  }, {
    key: "bindIframe",
    value: function bindIframe(el) {
      if (el && el.contentWindow) {
        el.contentWindow.onresize = throttleWrapper(this.setHeight);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          colSpan = _this$props.colSpan,
          children = _this$props.children;
      return (
        /*#__PURE__*/
        React.createElement("tr", {
          ref: this.bindElement
        },
        /*#__PURE__*/
        React.createElement("td", {
          style: {
            padding: 0
          },
          colSpan: colSpan
        },
        /*#__PURE__*/
        React.createElement("iframe", {
          title: "scroll",
          ref: this.bindIframe,
          style: iframeStyle
        }), children))
      );
    }
  }]);

  return Expand;
}(PureComponent);

export default Expand;